import React, { useEffect, useState } from "react";
import { withRouter } from "react-router-dom";
import { useDispatch } from "react-redux";
import { appAction, portfolioAction } from "../../../../actions";
import Axios from "axios";
import { API } from "../../../../utilities/api.config";
import { Box, Button, Grid, Typography } from "@material-ui/core";
import qs from "qs";

function DigitalOnboardingPage({ match, history, location }) {

  // TODO move to a configurable variable!
  const dispatch = useDispatch();
  const [ sessionUrl, setSessionUrl ] = useState('');
  // TODO: Need to synchronize the loading state in the iframe to the fetchingDoData state
  // const [ fetchingDoData, setFetchingDoData ] = useState(true);
  const [ err, setErr ] = useState(undefined);
  const doHost = sessionUrl ? new URL(sessionUrl).origin: "";

  const parsedQueryString = qs.parse(location.search, {
    ignoreQueryPrefix: true,
  });
  const { portfolioId } = parsedQueryString;

  const goBack = () => {
    dispatch(portfolioAction.resetQuikFormData());
    let backRoute;
    if (!!portfolioId) {
      backRoute = `/Portal/household/${match.params.householdId}/summary/${portfolioId}`
    } else {
      backRoute = `/Portal/household/${match.params.householdId}`
    }
    return history.replace(backRoute);
  }

  useEffect(() => {
    Axios
      .get(
        `${API.PORTFOLIO}/dosession/${match.params.doSessionId}/${match.params.householdId}`
      )
      .then(({ data }) => {
        // TODO: Need to synchronize the loading state in the iframe to the fetchingDoData state
        // setFetchingDoData(false);
        setSessionUrl(data.appLocation);
      }).catch(e => {
        setErr(e);
      });

      return () => {
        dispatch(portfolioAction.resetQuikFormData());
      }
  }, [])

  useEffect(() => {
    dispatch(appAction.setDigitalOnboardingNav(true));
    dispatch(appAction.toggleMainNav(false));
    dispatch(appAction.updateProgressStep(6));
  }, [ dispatch ]);

  useEffect(() => {
    const cb2 = (e) => {
      if (e.origin === doHost && e.data === "do::close") {
        goBack();
      }
    }

    window.addEventListener('message', cb2, false);

    return () => {
      window.removeEventListener('message', cb2);
    }
  }, [ sessionUrl ]);

  // TODO: Need to synchronize the loading state in the iframe to the fetchingDoData state
  // if (fetchingDoData) {
  //   return <Loading />
  // }
  
  return err ? (
    <Grid
      container
      direction="column"
      justify="center"
      alignItems="center"
      style={{ width: "100%", height: "100%" }}
    >
      <Typography variant="body">
        "Error while launching Onboarding screens."
      </Typography>
      <Button onClick={goBack} color="primary">
        Go Back
      </Button>
    </Grid>
  ) : (
    <Box
      id="doApp"
      data-session={sessionUrl}
      style={{
        width: "100%",
        height: "100%",
      }}
    >
      <iframe
        src={sessionUrl}
        title={`DO session`}
        width="100%"
        height="100%"
        style={{
          border: "none",
          marginBottom: "-7px", // Remove Cy scrollbar
        }}
      />
    </Box>
  );
}

export default withRouter(DigitalOnboardingPage)


// WEBPACK FOOTER //
// ./src/containers/Cy/components/DigitalOnboardingPage/index.jsx